import { gsap } from 'gsap';

export default function initMainMenu() {
  const nav = document.getElementById('header-main-nav');
  if (!nav) return;

  const header = document.getElementById('header');
  const links = nav.querySelectorAll('.main-nav-link');
  const classActive = 'active';
  const array = [];
  let currentIndex = null;
  const desktopMedia = window.matchMedia("(min-width: 992px)");

  // Function to show navigation.
  const showNav = (nav , flag)=>{
    // Set up a timeline.
    let tl = gsap.timeline();
    gsap.set(nav, {autoAlpha: 1});

    let firstScene;

    // Check if nav is closed or open and respond accordingly.
    if ( flag ) {

      // If true, fade in the navigation.
      firstScene = gsap.fromTo(nav, {autoAlpha: 0, yPercent: 0}, {autoAlpha: 1, duration: 0, onComplete: function() { nav.classList.add('active'); }});

    } else {

      // If flag is false, slide in the navigation from top.
      firstScene = gsap.fromTo(nav, {autoAlpha: 1, yPercent: -100}, {yPercent: 0, duration: 0.7, onComplete: function() { nav.classList.add('active'); }});

    }

    let secondScene;

    if(nav.getAttribute('id') === 'main-nav-search') {

      // If it's the search navigation, fade in the elements
      secondScene = gsap.fromTo(nav.querySelectorAll('[data-fade-up]'), {y: -40, opacity: 0}, {y: 0, opacity: 1, duration: 0.5, stagger: 0.2});

    } else {

      // Set the fade or slide in based on detected media.
      if (desktopMedia.matches) {

        // If it's desktop view, fade in the elements.
        gsap.set(nav.querySelectorAll('[data-mobile-scroll]'), {opacity: 1, xPercent: 0});
        secondScene = gsap.fromTo(nav.querySelectorAll('[data-fade-up]'), {y: -40, opacity: 0}, {y: 0, opacity: 1, duration: 0.5, stagger: 0.2});

      } else {

        // If it's mobile view, slide in the elements from left.
        gsap.set(nav.querySelectorAll('[data-fade-up]'), { opacity: 1});
        secondScene = gsap.fromTo(nav.querySelectorAll('[data-mobile-scroll]'), {xPercent: -100, opacity: 1}, {xPercent: 0, opacity: 1, duration: 0.6});

      }

    }

    // Adding both scenes to the timeline
    tl.add(firstScene).add(secondScene, '-=30%');
  }

  // Function to hide navigation.
  const hideNav = (nav, flag)=>{
     let firstScene, secondScene;

    // Removing active class from navigation
    nav.classList.remove('active');

    // Creating a gsap timeline with a completion callback to hide the navigation.
    let tl = gsap.timeline({
      onComplete: ()=>{
        gsap.set(nav, {autoAlpha: 0});
      }
    });

    // Defining first and second scenes based on flag.
    if( flag ) {

      firstScene = gsap.fromTo(nav, {autoAlpha: 1, yPercent: 0}, { autoAlpha: 0, duration: 0 });

    } else {

      // If flag is false, slide up the navigation
      firstScene = gsap.fromTo(nav, {autoAlpha: 1, yPercent: 0}, {yPercent: -100, duration: 0.3 });

      if (desktopMedia.matches) {

        // If it's desktop view, fade out the elements
        secondScene = gsap.to(nav.querySelectorAll('[data-fade-up]'),  {opacity: 0, duration: 0.1,  stagger: 0});

      } else {

        // If it's mobile view, fade out the elements
        secondScene = gsap.fromTo(nav.querySelectorAll('[data-mobile-scroll]'), { opacity: 1}, {opacity: 0, duration: 0.1});

      }

    }

    // Adding both scenes to the timeline
    tl.add(secondScene).add(firstScene);
  }

  // Iterate over navigation links to fade each in.
  links.forEach((link)=>{
    // Getting target element based on the data-target-id attribute of the link
    const target = document.getElementById(link.getAttribute('data-target-id'));
    let flagOpen = false;

    if(target) {
      // Initial setting of target with gsap
      gsap.set(target, {yPercent: -100, autoAlpha: 0});

      // Storing the link, target and open flag in array
      array.push({
        link,
        target,
        flagOpen,
      });

      // Adding event listener to show.bs.tab event for each link in target
      target.querySelectorAll('button[data-bs-toggle="tab"]').forEach((link)=>{
        link.addEventListener('show.bs.tab', e => {
          // Resetting the scroll top of parent element to 0 on tab show
          let attr = e.target.getAttribute('data-bs-target');
          while(attr.charAt(0) === '#') {
            attr = attr.substring(1);
          }
          const tab = document.getElementById(attr);
          const parent = tab.closest('.main-nav-panel-secondary');
          if(parent)  {
            parent.scrollTop = 0;
          }
          const mobileParent = tab.closest('.main-nav-wrapper');
          if(mobileParent)  {
            mobileParent.scrollTop = 0;
          }
        })
      });
    }
  });

  array.forEach((obj, i) => {

    // Adding click event listener to link
    obj.link.addEventListener('click', (e)=> {
      e.preventDefault();
      document.body.classList.remove('nav-open');
      document.body.classList.remove('nav-open-split');
      header.classList.remove('search-active');

      // If the target is main-nav-search, add search-active class to header
      if(obj.target.getAttribute('id') === 'main-nav-search') {
        header.classList.add('search-active');
      } else {
        header.classList.remove('search-active');
      }

      // Toggle navigation
      if(obj.flagOpen) {

        obj.flagOpen = false;
        obj.link.classList.remove(classActive);
        hideNav(obj.target);
        currentIndex = null;
        obj.link.setAttribute('aria-expanded', false);

      } else {

        obj.flagOpen = true;
        obj.link.classList.add(classActive);
        obj.link.setAttribute('aria-expanded', true);
        document.body.classList.add('nav-open');

        if(obj.target.getAttribute('id') === 'main-nav-search') {

          setTimeout(e=>{
            obj.target.querySelector('input').focus();
          }, 300)

        } else {

          document.body.classList.add('nav-open-split')

        }
        if(currentIndex !== null) {

          // If there is a current active link, deactivate it
          array[currentIndex].link.classList.remove(classActive);
          array[currentIndex].link.setAttribute('aria-expanded', false);

          // Close the currently open navigation
          array[currentIndex].flagOpen = false;
          hideNav(array[currentIndex].target, true);

          // Show the new navigation
          showNav(obj.target, true);

        } else {

          // If there is no currently active link, just show the navigation
          showNav(obj.target);

        }

        // Set the current index to the index of the clicked link
        currentIndex = i;

      }
    });

    obj.link.addEventListener('keydown', (e)=>{
      const target = e.target;
      if (e.code === 'Tab') {

        // If tab key is pressed...
        if(target.classList.contains('main-nav-link') && target.hasAttribute('aria-expanded') && target.getAttribute('aria-expanded') === 'true') {

          // If the target is a main navigation link and it is expanded...
          e.preventDefault();

          // Get all focusable elements in the target
          const focusElements =[...obj.target.querySelectorAll('a, button, input')];
          let focusElement;

          if(!e.shiftKey) {
            // If shift key is not pressed, find the first element that is not selected
            focusElement = focusElements.find(el => el.getAttribute('aria-selected') !== 'false');
          } else {
            // If shift key is pressed, find the first element in reverse order that is not selected
            const reversed = focusElements.reverse();
            reversed.shift();
            focusElement = focusElements.find(el =>!(el.getAttribute('aria-selected') === 'false' || el.closest('.d-lg-none') || (el.closest('.tab-pane') && !el.closest('.tab-pane').classList.contains('show'))));
          }

          // Set the focus on the found element.
          focusElement.focus();

        }
      }
    });

    // Add focus event listener to the accessibility jump link in the target.
    obj.target.querySelector('.accessibility-jump').addEventListener('focus', function(e) {
      e.preventDefault();

      // On focus, focus on the corresponding link instead.
      obj.link.focus();

    });

    // Add focus event listener to the target.
    obj.target.addEventListener('focus', e=>{
      e.preventDefault();

      // On focus, focus on the corresponding link instead.
      obj.link.focus();

    });

    // Close nav function for the event listeners
    const closeNavigation = () => {
      obj.flagOpen = false;
      obj.link.classList.remove(classActive);
      hideNav(obj.target);
      currentIndex = null;
      obj.link.setAttribute('aria-expanded', false);
      document.body.classList.remove('nav-open');
      document.body.classList.remove('nav-open-split');
      header.classList.remove('search-active');
      obj.link.focus();
    };

    // Escape key event listener to close navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && obj.flagOpen) {
        closeNavigation();
      }
    });

    // Close the search navigation if clicking outside it's modal
    document.addEventListener('click', (e) => {
      if (obj.target.getAttribute('id') === 'main-nav-search' && obj.flagOpen) {
        // Check that we're not clicking the search aside or button
        if (!obj.target.contains(e.target) && !obj.link.contains(e.target)) {
          closeNavigation();
        }
      }
    });

  });
}
